import { render, staticRenderFns } from "./UserMenuLegacy.vue?vue&type=template&id=6b205659"
import script from "./UserMenuLegacy.vue?vue&type=script&lang=js"
export * from "./UserMenuLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports